import React, { useEffect, useState } from "react"
import axios from "axios"
import Header from "../../../components/navigation/Header"
import { useNavigate, useSearchParams } from "react-router-dom"
import LoadingAnimation from "../../../components/general/LoadingAnimation"
import CreateCSFR from "../../../hooks/userAuthentication/CreateCSFR"

export default function ClubInvite(){
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const csrfToken = CreateCSFR({ name: "csrftoken" })
    const [queryParameters] = useSearchParams()
    const [displayMessage, setDisplayMessage] = useState("You've accepted a Club invitation!")

    useEffect(()=>{
        document.title = "Accept Club Invite"
        // Get the token from URL
        const token = queryParameters.get("token")

        if (!token) {
            setDisplayMessage("Error! Please try again and ensure the link is valid.")
            setIsLoading(false)
            return
        }
        if(csrfToken && csrfToken?.length > 0){
            axios.post(`${process.env.REACT_APP_SKILLJA_URL}/club-invite/`, {token:token}, { 
                headers: {
                    'X-CSRFToken': csrfToken,
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
            .then(res => {
                if (res.status === 200) {
                    setDisplayMessage("You're already a member of this club!")
                }
                else if (res.status === 201) {
                    setDisplayMessage("You've accepted a Club invitation!")
                }
            })
            .catch(error => {
                if (error.response) {
                    // the server responded with a status code that falls out of the range of 2xx
                    console.error('Error response:', error.response.data)
                    console.error('Status:', error.response.status)
                    console.error('Headers:', error.response.headers)
                } else if (error.request) {
                    // no response was received
                    console.error('No response received:', error.request)
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Error setting up request:', error.message)
                }
                console.error('Error config:', error.config)
            })
            .finally(()=>{
                setIsLoading(false)
            })
        }
    },[csrfToken])

    return (
        <div className="flex flex-col">
            <Header useCase="onboarding" />
            <section className="pt-40">
                {isLoading ?
                    <LoadingAnimation />
                :
                    <div className="flex flex-col justify-center items-center">
                        <p className="text-lg font-semibold">
                            {displayMessage}
                        </p>
                        <button
                            onClick={()=>navigate('/')}
                            className="form-btn mt-10 px-6"
                            aria-label="redirects to landing page"
                        >
                            Explore Coaches
                        </button>
                    </div>
                }
            </section>
        </div>
    )
}